import { useEffect, useState } from "react";
import API, { fmt } from "@/lib/api";
import { PageHeader, StatusPill, Loader } from "@/components/ui-bits";

export default function AdminReports() {
  const [txns, setTxns] = useState(null);
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");

  const load = () => {
    const params = {};
    if (type) params.type = type;
    if (status) params.status = status;
    API.get("/admin/transactions", { params }).then((r) => setTxns(r.data.transactions));
  };
  useEffect(() => { load(); }, [type, status]);

  const typeOpts = ["", "deposit_approved", "deposit_rejected", "package_activation",
    "creator_income", "lapse_income", "platform_fee", "magic_card_income",
    "withdrawal_request", "withdrawal_approved", "withdrawal_rejected", "pp_transfer", "admin_adjustment"];

  return (
    <div>
      <PageHeader title="Reports & System Ledger" subtitle="Full platform transaction ledger with type and status filters." testid="reports-header"
        right={
          <div className="flex gap-2">
            <select data-testid="report-type" value={type} onChange={(e) => setType(e.target.value)}
              className="rounded-xl bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white outline-none">
              {typeOpts.map((t) => <option key={t} value={t} className="bg-slate-900">{t ? t.replace(/_/g, " ") : "All types"}</option>)}
            </select>
            <select data-testid="report-status" value={status} onChange={(e) => setStatus(e.target.value)}
              className="rounded-xl bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white outline-none">
              {["", "completed", "pending", "rejected"].map((s) => <option key={s} value={s} className="bg-slate-900">{s || "All status"}</option>)}
            </select>
          </div>
        }
      />
      {!txns ? <Loader /> : (
        <div className="glass rounded-2xl p-2 sm:p-4" data-testid="ledger-table">
          {txns.length === 0 ? <p className="text-sm text-slate-500 py-10 text-center">No records.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500 border-b border-white/10">
                  <th className="py-3 px-3">Date</th><th className="py-3 px-3">User</th><th className="py-3 px-3">Type</th><th className="py-3 px-3">Gross</th>
                  <th className="py-3 px-3">Fee</th><th className="py-3 px-3">Net</th><th className="py-3 px-3">Source</th>
                  <th className="py-3 px-3">Destination</th><th className="py-3 px-3 text-right">Status</th>
                </tr></thead>
                <tbody>
                  {txns.map((t) => (
                    <tr key={t.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                      <td className="py-3 px-3 font-num text-slate-400 whitespace-nowrap">{new Date(t.created_at).toLocaleString()}</td>
                      <td className="py-3 px-3 whitespace-nowrap">
                        {t.referral_code ? <div className="font-num text-cyan-300 text-xs">{t.referral_code}</div> : <span className="text-xs text-slate-600">—</span>}
                        {t.user_name && <div className="text-[0.65rem] text-slate-500">{t.user_name}</div>}
                      </td>
                      <td className="py-3 px-3 text-white capitalize whitespace-nowrap">{t.type.replace(/_/g, " ")}</td>
                      <td className="py-3 px-3 font-num text-white">{fmt(t.gross)}</td>
                      <td className="py-3 px-3 font-num text-rose-400">{t.fee ? fmt(t.fee) : "—"}</td>
                      <td className="py-3 px-3 font-num text-emerald-300">{fmt(t.net)}</td>
                      <td className="py-3 px-3 text-xs font-num text-slate-500">{t.source}</td>
                      <td className="py-3 px-3 text-xs font-num text-slate-500">{t.destination}</td>
                      <td className="py-3 px-3 text-right"><StatusPill status={t.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
